import { Slot } from '../slot/slot';
import { DateTimeHelper } from '../../../../../util/date-time-helper';
import { ITimeBlockComponentItem } from '../../../types/time-block-component-item-types';
import { SlotMonthViewTimeBlockFacade } from '../slot/slot-month-view-time-block-facade';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Represents the slot data structure for the month view.
 */
@Injectable()
export class MonthViewSlotVectorService {
  public readonly setStartDate$ = new Subject<Date>();
  private readonly rowcount = 6;
  private readonly slotsPerWeeks = new Array<Slot[]>(this.rowcount);
  private startDate = null;

  constructor() {
    this.setStartDate$.subscribe((startDate) => {
      this.startDate = startDate;

      for (let i = 0; i < this.rowcount; i++) {
        this.slotsPerWeeks[i] = [];
      }
    });
  }

  /**
   * Return the slots for the week of date (return the row in the calendar view in which date lies)
   * @param date The date of which is used to retrieve the week row
   */
  public getSlotsPerWeek(date: Date): Slot[] {
    const daysDiff = DateTimeHelper.differenceInDays(date, this.startDate);
    const rowInCalendar = Math.floor(daysDiff / 7);
    return this.slotsPerWeeks[rowInCalendar];
  }

  public updateGeometry(
    updateGeometry: (slots: Slot[]) => ITimeBlockComponentItem[],
  ): ITimeBlockComponentItem[] {
    const updatedTimeBlocks = new Array<ITimeBlockComponentItem>();
    this.slotsPerWeeks.forEach((slots: Slot[]) => {
      updatedTimeBlocks.push(...updateGeometry(slots));
    });
    return updatedTimeBlocks;
  }

  /**
   * Restore inner day time blocks.
   */
  public removeWrapper(): void {
    this.slotsPerWeeks.forEach((slots: Slot[]) => {
      slots.forEach((slot: Slot) => {
        for (let i = 0; i < slot.timeBlocks.length; i++) {
          if (slot.timeBlocks[i].timeBlockModel.fixInterval === null) {
            const slotMonthViewTimeBlock = slot.timeBlocks[i] as SlotMonthViewTimeBlockFacade;
            slot.timeBlocks[i] = slotMonthViewTimeBlock.realTimeBlock;
          }
        }
      });
    });
  }
}
